import { autoinject } from "aurelia-framework";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";

@autoinject
export class DialogCreateSalesforceOpporunityConfirmation {

    public onYes: () => void;
    public onNo: () => void;

    constructor(private dialogClientService: DialogClientService) { }
    
    activate(model: { onYes: () => void, onNo: () => void }) {
        this.onYes = model.onYes;
        this.onNo = model.onNo;
    }

    //Yes
    yes() {
        if (this.onYes) {
            this.onYes();
            this.cancel();
        }
    }
    
    //No
    no() {
        if (this.onNo) {
            this.onNo();
            this.cancel();
        }
    }

    //Close dialog
    cancel() {
        this.dialogClientService.hide();
    }
}